// extracted by mini-css-extract-plugin
export default {"luruTaskInfo":"LuruTaskInfo_luruTaskInfo__JIYuw","separator":"LuruTaskInfo_separator__v53i1","icon":"LuruTaskInfo_icon__5CB7a"};